// Флаг «покупателя уже предупредили о комиссии платёжной системы» — по одному на заказ.
// localStorage может быть недоступен (приватный режим) — тогда помним хотя бы до перезагрузки страницы.
const shownInMemory = new Set();
const storageKey = orderId => `payment_commission_notice:${orderId}`;

export const wasCommissionNoticeShown = orderId => {
  if (!orderId) return true;
  if (shownInMemory.has(orderId)) return true;
  try {
    return window.localStorage.getItem(storageKey(orderId)) === "1";
  } catch {
    return false;
  }
};

export const markCommissionNoticeShown = orderId => {
  if (!orderId) return;
  shownInMemory.add(orderId);
  try {
    window.localStorage.setItem(storageKey(orderId), "1");
  } catch {
    // без localStorage хватит памяти страницы
  }
};
